import React from 'react';
import { StreamChat } from 'stream-chat';
import { noop } from '../utils/index.js';

const useClient = streamUser => {
    const [chatClient, setChatClient] = React.useState(null);
    React.useEffect(() => {
        if (!streamUser)
            return noop;
        // prevents application from setting stale client (user changed, for example)
        let didUserConnectInterrupt = false;
        const client = StreamChat.getInstance(streamUser.api_key, {
            baseURL: "https://chat.stream-chat.com",
            timeout: 0, // no timeout
        });
        const connectionPromise = client
            .connectUser({ id: streamUser.id }, streamUser.tokenProvider)
            .then(() => {
            if (!didUserConnectInterrupt)
                setChatClient(client);
        });
        return () => {
            didUserConnectInterrupt = true;
            setChatClient(null);
            // wait for connection to finish before initiating closing sequence
            connectionPromise
                .then(() => client.disconnectUser())
                .then(() => {
                console.log("connection closed");
            });
        };
    }, [streamUser === null || streamUser === undefined ? undefined : streamUser.id, streamUser === null || streamUser === undefined ? undefined : streamUser.api_key]);
    return chatClient;
};

export { useClient };
//# sourceMappingURL=use_client.js.map
